export function createStatusSnapshot(timeMs = 0) {
  const tick = Math.floor(Math.max(0, timeMs) / 1200)
  const modules = 5 + (tick % 4)
  const evals = 18 + ((tick * 3) % 9)
  const flows = 12 + ((tick * 2) % 6)
  const segments = [
    { code: 'FRONT', value: 'deployed' },
    { code: 'SAAS', value: `${modules} modules` },
    { code: 'CTRL', value: 'edge-ready' },
    { code: 'AI', value: `${evals} evals` },
    { code: 'AUTO', value: `${flows} flows` },
  ]

  return {
    segments,
    label: segments.map((segment) => `${segment.code} ● ${segment.value}`).join(' · '),
  }
}
